import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';

interface LinkProps {
    to?: string;
    href?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children: any;
    className?: string;
}

export default function Link(props: LinkProps): JSX.Element {
    const { to, href, className, children } = props;
    return (
        <LinkRouter to={to ? to : href ? href : '#'} className={`${className ? className : ''}`} href={href}>
            {children}
        </LinkRouter>
    );
}
